module.exports = __webpack_public_path__ + "static/media/1.edf248e3.png";